import { useQuery } from '@tanstack/react-query';
import { getAllGroupTemplates, UserKeys } from '../../../api/users-api';
import { RulesEngineForm } from './rules-engine-form-page';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

interface RulesEngineGroupTemplateDescriptionProps {
  selectedRule: RulesEngineForm;
}

export default function RulesEngineGroupTemplateDescription({
  selectedRule,
}: RulesEngineGroupTemplateDescriptionProps) {
  const groupTemplateId = selectedRule.groupSettingsInfo.groupTemplateId;

  const {
    data: groupTemplates,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [UserKeys.GroupTemplates],
    queryFn: () => getAllGroupTemplates(),
    enabled: !!groupTemplateId,
  });

  const template = groupTemplates?.find(
    (t) => t.id.toString() === groupTemplateId.toString()
  );

  const highlight = (text: string) => (
    <Box component="span" sx={{ fontWeight: 'bold' }}>
      {text}
    </Box>
  );

  if (isLoading) {
    return <Skeleton variant="text" width={300} />;
  }

  if (isError) {
    return (
      <Typography color="error.main">
        There was an error loading the group template.
      </Typography>
    );
  }

  if (!template) {
    return (
      <Typography color="error.main">
        Group template with ID {highlight(groupTemplateId.toString())} could not
        be found and may have been deleted.
      </Typography>
    );
  }

  return (
    <>
      Group template {highlight(template.groupTemplateName)} will be applied
      when this rule is triggered.
    </>
  );
}
